<script>
  import {onMount} from 'svelte';
  let { audio } = $props();
  onMount(async() => {
    refreshFsLightbox();
  });

</script>

{#if audio}
<div class="gallery-item -audio">
<a href='#audio-{audio.id}' data-fslightbox class="audio"><span class="icon audio-icon" aria-hidden="open audio"></span></a>
<div class="no-display">
  <audio id="audio-{audio.id}"  preload controls>
  <source src="{audio.gallery.audio}">
</audio>
</div>
</div>
{/if}
